import { observer } from 'mobx-react';
import React from 'react';
import { useSlate } from 'slate-react';
import { RichTextBoxUtils } from '../RichTextBoxUtils';
import { RichTextBoxElementType, RichTextBoxToolbarButtonBaseProps } from '../richTextEditorTypes';
import { RichTextBoxToolbarButton } from './RichTextBoxToolbarButton';

type RichTextBoxToolbarBlockButtonProps = {
    elementType: RichTextBoxElementType
} & RichTextBoxToolbarButtonBaseProps



export const RichTextBoxToolbarBlockButton = observer(({ elementType, ...props }: RichTextBoxToolbarBlockButtonProps) => {
    const editor = useSlate();
    const { attrs, ...trimmedProps } = props;
    const { onClick, ...trimmedAttrs } = attrs ?? { onClick: undefined };

    const active = RichTextBoxUtils.isBlockActive(editor, elementType);

    return (
        <RichTextBoxToolbarButton {...trimmedProps} isActive={active} attrs={{
            onClick: (event) => {
                RichTextBoxUtils.toggleBlock(editor, elementType, active);
                if (onClick)
                    onClick(event);
            }, ...trimmedAttrs
        }} />
    )
});
